import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Order } from 'services/action';
import { Form } from 'ui/components';

const initialState = {
  unit_price: 0,
};

export const FormUpdatePricing = ({ onSubmit, data }) => {
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state?.Form);
  const [{ unit_price }, setState] = React.useState(initialState);

  const $handleSubmit = async (e) => {
    const payload = {
      unit_price,
    };
    const req = await Dispatch(Order.$updatePrice(data?.id, payload));

    if (req?.message === 'success') {
      onSubmit();
    }
  };

  React.useEffect(() => {
    if (!data) return;

    setState((prevState) => ({
      ...prevState,
      unit_price: data?.total_charges,
    }));
  }, [data]);

  return (
    <Form autoComplete="off">
      <div className="row">
        <div className="col-md-12">
          <Form.Input
            value={unit_price}
            required
            onChange={(e) => {
              setState((prevState) => ({
                ...prevState,
                unit_price: e.target.valueNumber,
              }));
            }}
            type="number"
            label="Unit Price"
            error={StateForm?.errors?.unit_price}
          />
        </div>
      </div>

      <button
        className={
          StateForm?.loading
            ? 'btn-loading btn btn-primary px-3 w-100 mb-3'
            : 'btn btn-primary px-3 w-100 mb-3'
        }
        onClick={$handleSubmit}
        type="button"
        disabled={StateForm?.loading}
      >
        Simpan
      </button>
    </Form>
  );
};
